__webpack_require__.p = "/EQ_of_AI/";